// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreadInfo__container-dcd9b1 {
  margin-inline-start: 8px;
  color: var(--base-110);
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  display: inline-flex;
  align-items: center;
}

.ThreadInfo__back-efc189 {
  margin-inline-end: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/ThreadInfo/ThreadInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".container {\n  margin-inline-start: 8px;\n  color: var(--base-110);\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  display: inline-flex;\n  align-items: center;\n}\n\n.back {\n  margin-inline-end: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ThreadInfo__container-dcd9b1`,
	"back": `ThreadInfo__back-efc189`
};
module.exports = ___CSS_LOADER_EXPORT___;
